import { NotificationsPopup } from '@features/notifications';
import UserMenu from '@features/userMenu';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import type { AppBarProps } from '@mui/material';
import { AppBar, Box, Chip, IconButton, Toolbar, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { type FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LanguagePopover from 'src/components/LanguagePopover';
import LastDistributionData from 'src/components/LastDistributionData';
import OrganizationSetting from 'src/components/OrganizationSetting';
import { LogoAmaru } from 'src/components/logo/';
import DebtsAlertPopover from 'src/features/debtsAlert/components/DebtsAlertPopover';
import useAuth from 'src/hooks/useAuth';
import MenuIcon from 'src/icons/Menu';
import { useSelector } from 'src/store';
import DistributionIrrigationSelect from '../DistributionIrrigationSelect';

interface DashboardNavbarProps extends AppBarProps {
  toggleSidebar: () => void;
}

export const Navbar: FC<DashboardNavbarProps> = ({ toggleSidebar }) => {
  const { _ } = useLingui();
  const { user, isSimulating, stopUserSimulation } = useAuth();
  const navigate = useNavigate();

  const location = useLocation();

  const { intervalId } = useSelector((state) => state.global_config);

  const theme = useTheme();

  const isXS = useMediaQuery(theme.breakpoints.down('md'));

  // TODO: fjana. Unused?, remove
  useEffect(() => {
    const { pathname } = location;
    if (pathname !== '/device-configuration') {
      clearInterval(intervalId);
    }
  }, [location.pathname]);

  return (
    <AppBar
      position="sticky"
      sx={{
        gridColumn: '1 / span 2',
        borderBottom: 1,
        borderColor: 'divider',
      }}
      elevation={0}
    >
      <Toolbar disableGutters sx={{ pr: 3, pl: '9px' }}>
        <Box sx={{ display: 'flex', width: '100%' }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
            <Box display="flex" alignItems="center">
              <IconButton color="inherit" onClick={toggleSidebar} size="large">
                <MenuIcon fontSize="small" />
              </IconButton>
              <Box
                onClick={() => navigate({ pathname: '/' })}
                sx={{
                  width: 200,
                  cursor: 'pointer',
                  textAlign: 'center',
                  height: 64,
                  padding: '10px 0 8px 0',
                  display: {
                    xs: 'none',
                    lg: 'block',
                  },
                }}
              >
                <LogoAmaru />
              </Box>
            </Box>
            {!isXS && (
              <Box display="flex" flex={1} justifyContent="center" alignItems="center">
                <LastDistributionData />
              </Box>
            )}
            <Box display="flex" flexDirection="row" alignItems="center">
              <DistributionIrrigationSelect />
              <DebtsAlertPopover />
              {isSimulating && (
                <Chip
                  label={_(msg`Dejar de simular`)}
                  color="error"
                  onClick={() => {
                    if (!isSimulating) return;
                    stopUserSimulation();
                    navigate(0);
                  }}
                />
              )}
              <LanguagePopover />
              {user?.organization_id === 2 && <OrganizationSetting />}
              <NotificationsPopup />
              <Box px={0.5} />
              <UserMenu />
            </Box>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
